module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-input-control">\n    <div class="parameter-inputs">\n        ';
 _.each(parameters, function (value, label) { ;
__p += '\n            <input type="text" value="' +
__e( value ) +
'" class="code full-width" data-label="' +
__e( label ) +
'" placeholder="' +
__e( label ) +
'">\n        ';
 }); ;
__p += '\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/ParametersPropertiesView.tpl
// module id = 857
// module chunks = 0